module.exports = __webpack_public_path__ + "img/480-600kW分体式充电桩.aed5d8aa.png";